import { jsx as _jsx } from "react/jsx-runtime";
import { range } from "healthex-common/utils";
import { observer } from "mobx-react";
import * as React from "react";
import { useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { usePreciseSize } from "./usePreciseSize";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { useTranslation } from "react-i18next";
pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();
const options = {
    cMapUrl: "/cmaps/",
    standardFontDataUrl: "/standard_fonts/",
};
export const MultiPagePDFViewer = observer((props) => {
    const { t } = useTranslation(["common"]);
    const [loadedClassName, setLoadedClassName] = React.useState("");
    const [numberOfPages, setNumberOfPages] = React.useState(0);
    const containerRef = React.useRef(null);
    const [containerWidth, _containerHeight] = usePreciseSize(containerRef);
    const pagesRendered = [];
    const [renderedPages, setRenderedPages] = React.useState(new Set());
    useEffect(() => {
        if (numberOfPages > 0 && typeof props.initialPage === "number" && props.initialPage > 0) {
            if (renderedPages.has(props.initialPage)) {
                const pageElement = document.getElementById(`page_${props.initialPage}`);
                if (pageElement) {
                    pageElement.scrollIntoView({ behavior: "smooth" });
                }
            }
        }
    }, [numberOfPages, props.initialPage, renderedPages]);
    function updateLoadedClassName() {
        if (props.loadedClassName)
            setLoadedClassName(props.loadedClassName);
    }
    const handlePageRenderSuccess = (pageCallback) => {
        setRenderedPages((prev) => new Set(prev).add(pageCallback._pageIndex + 1));
        if (props.loadedClassName) {
            pagesRendered[pageCallback._pageIndex] = true;
            if (pagesRendered.length >= numberOfPages) {
                updateLoadedClassName();
            }
        }
    };
    return (_jsx("div", { ref: containerRef, style: { width: "100%" }, className: loadedClassName, children: _jsx(Document, { file: props.url, options: options, onLoadSuccess: (document) => {
                setNumberOfPages(document.numPages);
                if (document.numPages === 0)
                    updateLoadedClassName();
            }, onLoadError: () => updateLoadedClassName(), onInvalid: () => updateLoadedClassName(), onSourceError: () => updateLoadedClassName(), noData: _jsx("div", { className: props.loadedClassName, children: t("No PDF file specified.") }), loading: _jsx(LoadingPlaceholder, { w: 10, h: 60, text: "Loading PDF..." }), children: range(numberOfPages).map((pageIndex) => (_jsx("div", { id: `page_${pageIndex + 1}`, children: _jsx(Page, { pageIndex: pageIndex, width: containerWidth, onRenderSuccess: handlePageRenderSuccess }, pageIndex) }, pageIndex))) }) }));
});
